import {IBetWinData, IWalkOfShameData, IWalkOfShameGameData} from "./IWalkOfShameData";
import {WalkOfShameGameConfig} from "../../WalkOfShameGameConfig";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {WalkOfShameGameMode} from "../WalkOfShameGameMode";

export class WalkOfShameDataParser {

    constructor() {
    }

    public parseReels(rawData: IWalkOfShameData): string[][] {
        return rawData.reels;
    }

    public parseScatterPositions(rawData: IWalkOfShameData): number[] {
        const result: number[] = ArrayHelper.initArrayWithValues(WalkOfShameGameConfig.REELS_NUM, () => -1);
        for (let reelId: number = 1; reelId < 5; reelId++) {
            for (let symId: number = 1; symId < 5; symId++) {
                if (rawData.reels[reelId][symId] === "S") {
                    if (result[reelId] === -1) {
                        result[reelId] = symId;
                    } else {
                        debugger;
                        throw new Error(`Server gives more than 1 Scatter on reel ${reelId}!`);
                    }
                }
            }
        }

        return result;
    }

    // Game Data:
    public parseBetWins(rawData: IWalkOfShameGameData): IBetWinData[] {
        const retVal: IBetWinData[] = rawData.betWayWins;

        retVal.forEach((w: IBetWinData) => {
            w.reelWinPositions = this.calculateReelWinPos(rawData.evaluatedArea, w.symbol, w.length);
        });

        return retVal;
    }

    public parseWinRatio(winRatio: number): IWinRatioConfig | null {
        let ratioConfigs: IWinRatioConfig[] = WalkOfShameGameConfig.WIN_RATIOS,
            ratioConfig: IWinRatioConfig | undefined;

        for (let i: number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if (winRatio >= config.ratio) {
                ratioConfig = config;
                break;
            }
        }

        if (ratioConfig) {
            return {
                ratio: winRatio,
                name: ratioConfig.name,
                duration: ratioConfig.duration,
                bigWinLevel: ratioConfig.bigWinLevel
            }
        }
        return null;
    }

    public parseNearWinReels(scatterPositions: number[], wasFeatureBuy: boolean, mode: string): boolean[] {
        const result: boolean[] = ArrayHelper.initArrayWithValues(WalkOfShameGameConfig.REELS_NUM, () => false);

        // #65
        if (WalkOfShameGameConfig.IS_LUCKY_DRAW && mode === WalkOfShameGameMode.NORMAL) {
            result[0] = true;
            result[1] = true;

            return result;
        }

        if (wasFeatureBuy || mode !== WalkOfShameGameMode.NORMAL) {
            return result;
        }

        // reel id 1 has scatter
        if (scatterPositions[1] > -1) {
            // reel id 2 also has scatter, it means all remaining shall have anticipation
            if (scatterPositions[2] > -1) {
                result[3] = true;
                result[4] = true;

                return result;
            }
            // reel id 3 also has scatter, it means reel id 4 shall have anticipation
            if (scatterPositions[3] > -1) {
                result[4] = true;
            }
        } // reel id 2 and 3 has scatter, but not reel 1
        else if (scatterPositions[2] > -1 && scatterPositions[3] > -1) {
            result[4] = true;
        }

        return result;
    }

    private calculateReelWinPos(evaluatedArea: string[][], symbol: string, length: number): boolean[][] {
        const reelWinPos: boolean[][] = ArrayHelper.initArrayWithValues<boolean[]>(WalkOfShameGameConfig.REELS_NUM, (index: number) => {
            return ArrayHelper.initArrayWithValues<boolean>(evaluatedArea[index].length, () => false);
        });
        let connectedReel: boolean = false;
        for (let reelId: number = 0; reelId < length; reelId++) {
            connectedReel = false;
            for (let symId: number = 0; symId < evaluatedArea[reelId].length; symId++) {
                if (evaluatedArea[reelId][symId] === symbol || evaluatedArea[reelId][symId] === "W") {
                    reelWinPos[reelId][symId] = true;
                    connectedReel = true;
                }
            }
            if (!connectedReel) {
                break;
            }
        }
        return reelWinPos;
    }
}